import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "header block" }
const _hoisted_3 = { class: "enterprise-basic" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "detail-value" }
const _hoisted_6 = { class: "block" }
const _hoisted_7 = { class: "header" }
const _hoisted_8 = { class: "search" }
const _hoisted_9 = { class: "table" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "nickName" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_export_button = _resolveComponent("export-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode(" 派遣单位名称：" + _toDisplayString(_ctx.serveCompanyName) + " ", 1),
          _cache[7] || (_cache[7] = _createElementVNode("span", { style: {"display":"inline-block","width":"50px"} }, null, -1)),
          _createTextVNode(" 项目名称：" + _toDisplayString(_ctx.projectName), 1)
        ]),
        _createElementVNode("div", null, [
          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "detail-key" }, "创建时间：", -1)),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.createTime), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "请输入人员信息",
            class: "input search-input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
            onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.searchText]
          ]),
          _createElementVNode("button", {
            class: "btn",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
          }, "搜索"),
          _createElementVNode("button", {
            class: "btn-white",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args)))
          }, "重置")
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_export_button, {
            type: "success",
            onExport: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onExport()))
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode("导出名单")
            ])),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_table, {
          data: _ctx.tableData,
          style: {"width":"100%"},
          "header-row-style": { color: '#202536' },
          "row-style": { color: '#5E617D' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "workerName",
              label: "员工姓名"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", {
                  class: _normalizeClass([scope.row.nickName?.length ?? 0 + scope.row.workerName.length <= 10 ? 'align-items' : ''])
                }, [
                  _createElementVNode("div", null, _toDisplayString(scope.row.workerName), 1),
                  (scope.row.nickName)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_el_tooltip, {
                          class: "box-item",
                          effect: "dark",
                          content: "此处为备注名",
                          placement: "top-start"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_11, _toDisplayString(scope.row.nickName ? '('+ scope.row.nickName +')' : ''), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "sex",
              label: "性别"
            }),
            _createVNode(_component_el_table_column, {
              prop: "idCardNo",
              label: "身份证号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "bankCardNo",
              label: "银行卡号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "openBankAddress",
              label: "开户行"
            }),
            _createVNode(_component_el_table_column, {
              prop: "phone",
              label: "手机号"
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(_component_el_pagination, {
          class: "pagination",
          currentPage: _ctx.pageNum,
          "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pageNum) = $event)),
          "page-sizes": [10, 30, 50, 100],
          "page-size": _ctx.pageSize,
          "onUpdate:pageSize": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pageSize) = $event)),
          layout: "total, sizes, prev, pager, next, jumper",
          total: _ctx.total,
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
      ])
    ])
  ]))
}